import { useContext } from 'react';
import { DashboardSelectionContext } from '../contexts/DashboardSelectionContext';

// ----------------------------------------------------------------------

const useDashboardSelection = () => useContext(DashboardSelectionContext);

export default useDashboardSelection;
